import {CookieManager} from '../../modules/cookie.js';
import {applyImageLightbox} from '../../modules/imageLightbox.js';
import {Auth} from '../../modules/auth.js';
import {injectTableOfContents} from '../../modules/tableOfContentsInjector.js';
import {NetworkError} from '../../modules/userDefinedExceptions.js';
import {t} from '../../localization/translate.js';
import '../../components/cards/course.js';

/**
 * Add social signal for promoting 'Why Join IxDF' page.
 */
function registerToasters() {
    const COOKIE_NAME = 'why_join_us_popup_dismissed';
    const isSignalDismissed = !!CookieManager.read(COOKIE_NAME);

    if (!isSignalDismissed) {
        // Get number of members to display in the social signal
        const numberOfMembersElement = document.querySelector('[data-number-of-members]');
        if (!numberOfMembersElement) {
            return;
        }
        const numberOfMembers = /** @type {HTMLElement} */ (numberOfMembersElement).dataset.numberOfMembers;

        import('../../modules/toaster.js').then(({Toaster}) => {
            setTimeout(() => {
                // If a modal is open, wait 5 sec and try again. It's because
                // these social signals and modals can't be open simultaneously.
                const openedDialog = document.querySelector('dialog[open]');
                if (openedDialog) {
                    openedDialog.addEventListener('close', registerToasters, {once: true});
                } else {
                    Toaster.info(t('Learn why :members enrolled in IxDF courses', {members: numberOfMembers}), null, {
                        toasterClass: ['toaster', 'toaster--link'],
                        onClose: function () {
                            CookieManager.write(COOKIE_NAME, 1, {
                                days: 90,
                            });
                        },
                        onclick: function () {
                            CookieManager.write(COOKIE_NAME, 1, {
                                days: 90,
                            });
                            window.location.href = '/why-join-us'; // @route 'why-join-us.index'
                        },
                    });
                }
            }, 5000);
        });
    }
}

/**
 * Add available upcoming courses' cards into the sidebar.
 *
 * @param {string} publicationType
 * @param {string} publicationId
 */
async function injectCourseAd(publicationType, publicationId) {
    const {getInjectableElements} = await import('../../../js/modules/courseAdLocator.js');
    const containers = getInjectableElements(document.querySelector('.js-adArea'));
    if (!containers.length) {
        return;
    }

    const {addCourseAd} = await import('../../../js/modules/courseAdInjector.js');
    try {
        // CourseSchedule cards handle their own countdowns via resources/js/components/cards/course.js
        await addCourseAd(containers, publicationType, publicationId);
    } catch (error) {
        // Ad blockers reject the ad-code request outright: the sidebar then stays without
        // course cards, which is the intended degradation. Every other failure is a real one.
        if (!(error instanceof NetworkError)) {
            throw error;
        }
    }
}

/**
 * Init page, register event handlers
 */
function initPage() {
    // If the user is a guest, display Social Signals
    if (Auth.guest()) {
        registerToasters();
    }

    /** @type {HTMLElement|null} */
    const articleContainer = document.querySelector('.js-tableOfContents');

    if (articleContainer) {
        injectTableOfContents(articleContainer, '.rteContent');
    }

    /*
     * Get if it's been defined in the view to
     * display the upcoming courses.
     */
    const doWeNeedToShowUpcomingCourses = /** @type {HTMLInputElement} */ (document.getElementById('js-showUpcomingCourses')).value === 'show';

    if (doWeNeedToShowUpcomingCourses) {
        // Get current publication type and id.
        let publicationType = /** @type {HTMLInputElement} */ (document.getElementById('js-publicationType')).value;
        let publicationId = /** @type {HTMLInputElement} */ (document.getElementById('js-publicationId')).value;

        // Inject course ad from the publication type and id
        injectCourseAd(publicationType, publicationId);
    }

    // Make all images in content has lightbox feature, but images in the any widget
    applyImageLightbox([...document.querySelectorAll('.js-lightbox :is(img, video.video-gif):not(.rteContent__isolatedBlock)')]);
}

// init page when the document is ready
document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initPage) : initPage();
